import PropTypes from "prop-types"
import ContributorsDetailsTable from "components/contributors-details-table"
import ContributorsOptions from "components/contributors-options"
import { useTrack } from "helpers/analytics"
import "./style.scss"

function ContributorsDetails({
  selectedContributorCategory,
  data,
  selectedGroup,
  selectedGroupSiblings,
  selectedBasket,
  showGroup,
  hideGroup,
  setGrouping,
  currentGrouping,
  groupedData,
  openFactorProfile,
  openSecurityProfile,
  openCompositeSecurity,
  sort,
  sortOrder,
  availableRollups,
  contributorsSummaryText,
  csvData,
  refEquityOverride,
  enableBasketDrillDown,
  groupsDropdownColumns,
  page,
  setPage,
}) {
  const trackExcelDownload = useTrack({
    type: "composite-analyze-concentration-contributors-download",
  })

  return (
    <div className="contributors-details-wrapper">
      <ContributorsOptions
        contributorsSummaryText={contributorsSummaryText}
        availableRollups={availableRollups}
        setGrouping={setGrouping}
        currentGrouping={currentGrouping}
        selectedGroup={selectedGroup}
        csvData={csvData}
        trackExcelDownload={trackExcelDownload}
      />
      <ContributorsDetailsTable
        {...{
          selected: selectedContributorCategory,
          data,
          openSecurityProfile,
          openFactorProfile,
          openCompositeSecurity,
          contributorsGrouping: currentGrouping,
          selectedGroup,
          selectedGroupSiblings,
          groupsDropdownColumns,
          selectedBasket,
          showGroup,
          hideGroup,
          groupedData,
          sort,
          order: sortOrder,
          refEquityOverride,
          enableBasketDrillDown,
          page,
          setPage,
        }}
      />
    </div>
  )
}

ContributorsDetails.propTypes = {
  account: PropTypes.string.isRequired,
  modelId: PropTypes.string.isRequired,
  positionSetId: PropTypes.string.isRequired,
  positionSetType: PropTypes.string.isRequired,
  positionSetName: PropTypes.string.isRequired,
  segment: PropTypes.object,
  classifications: PropTypes.array,
  contributorsSummaryText: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]).isRequired,
  availableRollups: PropTypes.array.isRequired,
  setGrouping: PropTypes.func.isRequired,
  currentGrouping: PropTypes.object,
  csvData: PropTypes.object.isRequired,
  selectedContributorCategory: PropTypes.object.isRequired,
  data: PropTypes.array.isRequired,
  openSecurityProfile: PropTypes.func.isRequired,
  openFactorProfile: PropTypes.func.isRequired,
  openCompositeSecurity: PropTypes.func.isRequired,
  selectedGroup: PropTypes.object,
  selectedGroupSiblings: PropTypes.array,
  selectedBasket: PropTypes.object,
  showGroup: PropTypes.func.isRequired,
  hideGroup: PropTypes.func.isRequired,
  groupedData: PropTypes.array,
  sort: PropTypes.func.isRequired,
  sortOrder: PropTypes.object.isRequired,
  refEquityOverride: PropTypes.bool,
  enableBasketDrillDown: PropTypes.bool,
  groupsDropdownColumns: PropTypes.array,
  page: PropTypes.number.isRequired,
  setPage: PropTypes.func.isRequired,
  currency: PropTypes.string,
  expand: PropTypes.bool,
}

export default ContributorsDetails
